import { Text } from '@fluentui/react';
import styles from './Tag.module.scss';
import clsx from 'clsx';

export interface TagProps {
  /** Content to be displayed inside the tag */
  children: React.ReactNode;
  /** Additional class name(s) to apply */
  className?: string;
  /** Optional color variant */
  variant?: 'default' | 'neutral' | 'brand' | 'success' | 'warning' | 'error';
  /** Optional title for tooltip */
  title?: string;
}

export const Tag: React.FC<TagProps> = ({ children, className, variant = 'default', title }) => {
  return (
    <div className={clsx(styles.tag, styles[variant], className)} title={title}>
      <Text variant="small" className={styles.text}>
        {children}
      </Text>
    </div>
  );
};
